import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'prospect'

export const LIST_REQUEST = `${prefix}/LIST_REQUEST`
export const LIST_SUCCESS = `${prefix}/LIST_SUCCESS`
export const LIST_FAILURE = `${prefix}/LIST_FAILURE`

export const listProspects = createAction((params: object) => ({
  type: [LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE],
  promise: (api: IApi) => api.prospect.list(params),
  params,
}))

export const CREATE_REQUEST = `${prefix}/CREATE_REQUEST`
export const CREATE_SUCCESS = `${prefix}/CREATE_SUCCESS`
export const CREATE_FAILURE = `${prefix}/CREATE_FAILURE`

export const createProspect = createAction((data: object) => ({
  type: [CREATE_REQUEST, CREATE_SUCCESS, CREATE_FAILURE],
  promise: (api: IApi) => api.prospect.create(data),
}))

export const SHOW_REQUEST = `${prefix}/SHOW_REQUEST`
export const SHOW_SUCCESS = `${prefix}/SHOW_SUCCESS`
export const SHOW_FAILURE = `${prefix}/SHOW_FAILURE`

export const show = createAction((id: string) => ({
  type: [SHOW_REQUEST, SHOW_SUCCESS, SHOW_FAILURE],
  promise: (api: IApi) => api.prospect.show(id),
}))

export const SHOW_FOLDERS_REQUEST = `${prefix}/SHOW_FOLDERS_REQUEST`
export const SHOW_FOLDERS_SUCCESS = `${prefix}/SHOW_FOLDERS_SUCCESS`
export const SHOW_FOLDERS_FAILURE = `${prefix}/SHOW_FOLDERS_FAILURE`

export const showFoldersInfo = createAction((id: string) => ({
  type: [SHOW_FOLDERS_REQUEST, SHOW_FOLDERS_SUCCESS, SHOW_FOLDERS_FAILURE],
  promise: (api: IApi) => api.prospect.showFoldersInfo(id),
}))

export const LOAD_OVERVIEW_FEED_REQUEST = `${prefix}/LOAD_OVERVIEW_FEED_REQUEST`
export const LOAD_OVERVIEW_FEED_SUCCESS = `${prefix}/LOAD_OVERVIEW_FEED_SUCCESS`
export const LOAD_OVERVIEW_FEED_FAILURE = `${prefix}/LOAD_OVERVIEW_FEED_FAILURE`

export const loadOverviewFeed = createAction(
  (id: string, options: { skipLoader?: boolean } = {}) => ({
    type: [LOAD_OVERVIEW_FEED_REQUEST, LOAD_OVERVIEW_FEED_SUCCESS, LOAD_OVERVIEW_FEED_FAILURE],
    promise: (api: IApi) => api.prospect.overviewFeed(id),
    // Background refreshes after add/complete pass skipLoader so the Timeline
    // doesn't flash its skeleton — the row updates in place instead.
    params: { skipLoader: options.skipLoader },
  }),
)

export const DRAFT_SCHEDULING_EMAIL_REQUEST = `${prefix}/DRAFT_SCHEDULING_EMAIL_REQUEST`
export const DRAFT_SCHEDULING_EMAIL_SUCCESS = `${prefix}/DRAFT_SCHEDULING_EMAIL_SUCCESS`
export const DRAFT_SCHEDULING_EMAIL_FAILURE = `${prefix}/DRAFT_SCHEDULING_EMAIL_FAILURE`

export const draftSchedulingEmail = createAction((id: string) => ({
  type: [
    DRAFT_SCHEDULING_EMAIL_REQUEST,
    DRAFT_SCHEDULING_EMAIL_SUCCESS,
    DRAFT_SCHEDULING_EMAIL_FAILURE,
  ],
  promise: (api: IApi) => api.prospect.draftSchedulingEmail(id),
}))

export const HIDE = `${prefix}/HIDE`

export const hide = () => ({
  type: HIDE,
})

export const UPDATE_REQUEST = `${prefix}/UPDATE_REQUEST`
export const UPDATE_SUCCESS = `${prefix}/UPDATE_SUCCESS`
export const UPDATE_FAILURE = `${prefix}/UPDATE_FAILURE`

export const update = createAction((id: string, data: object) => ({
  type: [UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE],
  promise: (api: IApi) => api.prospect.update(id, data),
}))

export const START_REPORTING_REQUEST = `${prefix}/START_REPORTING_REQUEST`
export const START_REPORTING_SUCCESS = `${prefix}/START_REPORTING_SUCCESS`
export const START_REPORTING_FAILURE = `${prefix}/START_REPORTING_FAILURE`

export const startReporting = createAction((id: string, data?: object) => ({
  type: [START_REPORTING_REQUEST, START_REPORTING_SUCCESS, START_REPORTING_FAILURE],
  promise: (api: IApi) => api.prospect.startReporting(id, data),
}))

export const UPDATE_REPORTING_REQUEST = `${prefix}/UPDATE_REPORTING_REQUEST`
export const UPDATE_REPORTING_SUCCESS = `${prefix}/UPDATE_REPORTING_SUCCESS`
export const UPDATE_REPORTING_FAILURE = `${prefix}/UPDATE_REPORTING_FAILURE`

export const updateReporting = createAction((id: string, data: object | FormData) => ({
  type: [UPDATE_REPORTING_REQUEST, UPDATE_REPORTING_SUCCESS, UPDATE_REPORTING_FAILURE],
  promise: (api: IApi) => api.prospect.updateReporting(id, data),
  params: data,
}))

export const UPDATE_LOST_DEAL_NOTES_REQUEST = `${prefix}/UPDATE_LOST_DEAL_NOTES_REQUEST`
export const UPDATE_LOST_DEAL_NOTES_SUCCESS = `${prefix}/UPDATE_LOST_DEAL_NOTES_SUCCESS`
export const UPDATE_LOST_DEAL_NOTES_FAILURE = `${prefix}/UPDATE_LOST_DEAL_NOTES_FAILURE`

export const updateLostDealNotes = createAction((id: string, data: { notes: string }) => ({
  type: [
    UPDATE_LOST_DEAL_NOTES_REQUEST,
    UPDATE_LOST_DEAL_NOTES_SUCCESS,
    UPDATE_LOST_DEAL_NOTES_FAILURE,
  ],
  promise: (api: IApi) => api.prospect.updateLostDealNotes(id, data),
}))

export const LIST_INVENTORY_REQUEST = `${prefix}/LIST_INVENTORY_REQUEST`
export const LIST_INVENTORY_SUCCESS = `${prefix}/LIST_INVENTORY_SUCCESS`
export const LIST_INVENTORY_FAILURE = `${prefix}/LIST_INVENTORY_FAILURE`

export const listInventory = createAction((id: string, params: object) => ({
  type: [LIST_INVENTORY_REQUEST, LIST_INVENTORY_SUCCESS, LIST_INVENTORY_FAILURE],
  promise: (api: IApi) => api.prospect.listInventory(id, params),
  params,
}))

export const PULL_REPORTS_REQUEST = `${prefix}/PULL_REPORTS_REQUEST`
export const PULL_REPORTS_SUCCESS = `${prefix}/PULL_REPORTS_SUCCESS`
export const PULL_REPORTS_FAILURE = `${prefix}/PULL_REPORTS_FAILURE`

export const pullReports = createAction((id: string, params?: object) => ({
  type: [PULL_REPORTS_REQUEST, PULL_REPORTS_SUCCESS, PULL_REPORTS_FAILURE],
  promise: (api: IApi) => api.prospect.pullReports(id, params),
}))

export const CREATE_PROSPECT_TERMS_REQUEST = `${prefix}/CREATE_PROSPECT_TERMS_REQUEST`
export const CREATE_PROSPECT_TERMS_SUCCESS = `${prefix}/CREATE_PROSPECT_TERMS_SUCCESS`
export const CREATE_PROSPECT_TERMS_FAILURE = `${prefix}/CREATE_PROSPECT_TERMS_FAILURE`

export const createProspectTerms = createAction((id: string, data: object) => ({
  type: [
    CREATE_PROSPECT_TERMS_REQUEST,
    CREATE_PROSPECT_TERMS_SUCCESS,
    CREATE_PROSPECT_TERMS_FAILURE,
  ],
  promise: (api: IApi) => api.prospect.createProspectTerms(id, data),
}))

export const UPDATE_PROSPECT_TERMS_REQUEST = `${prefix}/UPDATE_PROSPECT_TERMS_REQUEST`
export const UPDATE_PROSPECT_TERMS_SUCCESS = `${prefix}/UPDATE_PROSPECT_TERMS_SUCCESS`
export const UPDATE_PROSPECT_TERMS_FAILURE = `${prefix}/UPDATE_PROSPECT_TERMS_FAILURE`

export const updateProspectTerms = createAction(
  (id: string, prospectTermsId: string, data: object) => ({
    type: [
      UPDATE_PROSPECT_TERMS_REQUEST,
      UPDATE_PROSPECT_TERMS_SUCCESS,
      UPDATE_PROSPECT_TERMS_FAILURE,
    ],
    promise: (api: IApi) => api.prospect.updateProspectTerms(id, prospectTermsId, data),
  }),
)

export const RENAME_REQUEST = `${prefix}/RENAME_REQUEST`
export const RENAME_SUCCESS = `${prefix}/RENAME_SUCCESS`
export const RENAME_FAILURE = `${prefix}/RENAME_FAILURE`

export const rename = createAction((id: string, name: string) => ({
  type: [RENAME_REQUEST, RENAME_SUCCESS, RENAME_FAILURE],
  promise: (api: IApi) => api.prospect.rename(id, name),
  params: { id, name },
}))

export const DELETE_PROSPECT_TERMS_REQUEST = `${prefix}/DELETE_PROSPECT_TERMS_REQUEST`
export const DELETE_PROSPECT_TERMS_SUCCESS = `${prefix}/DELETE_PROSPECT_TERMS_SUCCESS`
export const DELETE_PROSPECT_TERMS_FAILURE = `${prefix}/DELETE_PROSPECT_TERMS_FAILURE`

export const deleteProspectTerms = createAction((id: string, prospectTermsId: string) => ({
  type: [
    DELETE_PROSPECT_TERMS_REQUEST,
    DELETE_PROSPECT_TERMS_SUCCESS,
    DELETE_PROSPECT_TERMS_FAILURE,
  ],
  promise: (api: IApi) => api.prospect.deleteProspectTerms(id, prospectTermsId),
}))

export const LIST_PROSPECT_TERMS_REQUEST = `${prefix}/LIST_PROSPECT_TERMS_REQUEST`
export const LIST_PROSPECT_TERMS_SUCCESS = `${prefix}/LIST_PROSPECT_TERMS_SUCCESS`
export const LIST_PROSPECT_TERMS_FAILURE = `${prefix}/LIST_PROSPECT_TERMS_FAILURE`

export const listProspectTerms = createAction((id: string) => ({
  type: [LIST_PROSPECT_TERMS_REQUEST, LIST_PROSPECT_TERMS_SUCCESS, LIST_PROSPECT_TERMS_FAILURE],
  promise: (api: IApi) => api.prospect.listProspectTerms(id),
}))

export const GENERATE_TERM_SHEET_REQUEST = `${prefix}/GENERATE_TERM_SHEET_REQUEST`
export const GENERATE_TERM_SHEET_SUCCESS = `${prefix}/GENERATE_TERM_SHEET_SUCCESS`
export const GENERATE_TERM_SHEET_FAILURE = `${prefix}/GENERATE_TERM_SHEET_FAILURE`

export const generateTermSheet = createAction((id: string, prospectTermsId: string) => ({
  type: [GENERATE_TERM_SHEET_REQUEST, GENERATE_TERM_SHEET_SUCCESS, GENERATE_TERM_SHEET_FAILURE],
  promise: (api: IApi) => api.prospect.generateTermSheet(id, prospectTermsId),
}))

export const UPDATE_FINANCIALS_DATES_REQUEST = `${prefix}/UPDATE_FINANCIALS_DATES_REQUEST`
export const UPDATE_FINANCIALS_DATES_SUCCESS = `${prefix}/UPDATE_FINANCIALS_DATES_SUCCESS`
export const UPDATE_FINANCIALS_DATES_FAILURE = `${prefix}/UPDATE_FINANCIALS_DATES_FAILURE`

export const updateFinancialsDates = createAction((data: object | FormData) => ({
  type: [
    UPDATE_FINANCIALS_DATES_REQUEST,
    UPDATE_FINANCIALS_DATES_SUCCESS,
    UPDATE_FINANCIALS_DATES_FAILURE,
  ],
  promise: (api: IApi) => api.prospect.updateFinancialsDates(data),
}))

export const LIST_PROSPECT_REPORTING_REQUEST = `${prefix}/LIST_PROSPECT_REPORTING_REQUEST`
export const LIST_PROSPECT_REPORTING_SUCCESS = `${prefix}/LIST_PROSPECT_REPORTING_SUCCESS`
export const LIST_PROSPECT_REPORTING_FAILURE = `${prefix}/LIST_PROSPECT_REPORTING_FAILURE`

export const listProspectReporting = createAction((data: object) => ({
  type: [
    LIST_PROSPECT_REPORTING_REQUEST,
    LIST_PROSPECT_REPORTING_SUCCESS,
    LIST_PROSPECT_REPORTING_FAILURE,
  ],
  promise: (api: IApi) => api.prospect.listProspectReporting(data),
  params: data,
}))

export const HIDE_PROSPECT_REPORTING = `${prefix}/HIDE_PROSPECT_REPORTING`

export const hideProspectReporting = () => ({
  type: HIDE_PROSPECT_REPORTING,
})

export const UPDATE_REPORTING_FLOW_ADDITIONAL_REQUEST = `${prefix}/UPDATE_REPORTING_FLOW_ADDITIONAL_REQUEST`
export const UPDATE_REPORTING_FLOW_ADDITIONAL_SUCCESS = `${prefix}/UPDATE_REPORTING_FLOW_ADDITIONAL_SUCCESS`
export const UPDATE_REPORTING_FLOW_ADDITIONAL_FAILURE = `${prefix}/UPDATE_REPORTING_FLOW_ADDITIONAL_FAILURE`

export const updateReportingFlowAdditionalData = createAction(
  (id: string, flowId: string, data: object) => ({
    type: [
      UPDATE_REPORTING_FLOW_ADDITIONAL_REQUEST,
      UPDATE_REPORTING_FLOW_ADDITIONAL_SUCCESS,
      UPDATE_REPORTING_FLOW_ADDITIONAL_FAILURE,
    ],
    promise: (api: IApi) => api.prospect.updateReportingFlowAdditionalData(id, flowId, data),
  }),
)

export const SHOW_INVENTORY_SUMMARY_INFO_REQUEST = `${prefix}/SHOW_INVENTORY_SUMMARY_INFO_REQUEST`
export const SHOW_INVENTORY_SUMMARY_INFO_SUCCESS = `${prefix}/SHOW_INVENTORY_SUMMARY_INFO_SUCCESS`
export const SHOW_INVENTORY_SUMMARY_INFO_FAILURE = `${prefix}/SHOW_INVENTORY_SUMMARY_INFO_FAILURE`

export const showInventorySummaryInfo = createAction((id: string) => ({
  type: [
    SHOW_INVENTORY_SUMMARY_INFO_REQUEST,
    SHOW_INVENTORY_SUMMARY_INFO_SUCCESS,
    SHOW_INVENTORY_SUMMARY_INFO_FAILURE,
  ],
  promise: (api: IApi) => api.prospect.showInventorySummaryInfo(id),
}))

export const SHOW_CASH_FLOW_SUMMARY_INFO_REQUEST = `${prefix}/SHOW_CASH_FLOW_SUMMARY_INFO_REQUEST`
export const SHOW_CASH_FLOW_SUMMARY_INFO_SUCCESS = `${prefix}/SHOW_CASH_FLOW_SUMMARY_INFO_SUCCESS`
export const SHOW_CASH_FLOW_SUMMARY_INFO_FAILURE = `${prefix}/SHOW_CASH_FLOW_SUMMARY_INFO_FAILURE`

export const showCashFlowSummaryInfo = createAction((id: string, params: object) => ({
  type: [
    SHOW_CASH_FLOW_SUMMARY_INFO_REQUEST,
    SHOW_CASH_FLOW_SUMMARY_INFO_SUCCESS,
    SHOW_CASH_FLOW_SUMMARY_INFO_FAILURE,
  ],
  promise: (api: IApi) => api.prospect.showCashFlowSummaryInfo(id, params),
  params,
}))

export const SHOW_TERM_STRUCTURE_SUMMARY_INFO_REQUEST = `${prefix}/SHOW_TERM_STRUCTURE_SUMMARY_INFO_REQUEST`
export const SHOW_TERM_STRUCTURE_SUMMARY_INFO_SUCCESS = `${prefix}/SHOW_TERM_STRUCTURE_SUMMARY_INFO_SUCCESS`
export const SHOW_TERM_STRUCTURE_SUMMARY_INFO_FAILURE = `${prefix}/SHOW_TERM_STRUCTURE_SUMMARY_INFO_FAILURE`

export const showTermStructureSummaryInfo = createAction((id: string) => ({
  type: [
    SHOW_TERM_STRUCTURE_SUMMARY_INFO_REQUEST,
    SHOW_TERM_STRUCTURE_SUMMARY_INFO_SUCCESS,
    SHOW_TERM_STRUCTURE_SUMMARY_INFO_FAILURE,
  ],
  promise: (api: IApi) => api.prospect.showTermStructureSummaryInfo(id),
}))

export const UPDATE_DATE_AR_REQUEST = `${prefix}/UPDATE_DATE_AR_REQUEST`
export const UPDATE_DATE_AR_SUCCESS = `${prefix}/UPDATE_DATE_AR_SUCCESS`
export const UPDATE_DATE_AR_FAILURE = `${prefix}/UPDATE_DATE_AR_FAILURE`

export const updateARDate = createAction((data: object | FormData) => ({
  type: [UPDATE_DATE_AR_REQUEST, UPDATE_DATE_AR_SUCCESS, UPDATE_DATE_AR_FAILURE],
  promise: (api: IApi) => api.prospect.updateDate(data),
}))

export const UPDATE_DATE_AP_REQUEST = `${prefix}/UPDATE_DATE_AP_REQUEST`
export const UPDATE_DATE_AP_SUCCESS = `${prefix}/UPDATE_DATE_AP_SUCCESS`
export const UPDATE_DATE_AP_FAILURE = `${prefix}/UPDATE_DATE_AP_FAILURE`

export const updateAPDate = createAction((data: object | FormData) => ({
  type: [UPDATE_DATE_AP_REQUEST, UPDATE_DATE_AP_SUCCESS, UPDATE_DATE_AP_FAILURE],
  promise: (api: IApi) => api.prospect.updateDate(data),
}))

export const GET_DATE_AP_REQUEST = `${prefix}/GET_DATE_AP_REQUEST`
export const GET_DATE_AP_SUCCESS = `${prefix}/GET_DATE_AP_SUCCESS`
export const GET_DATE_AP_FAILURE = `${prefix}/GET_DATE_AP_FAILURE`

export const getAPDate = createAction((data: object | FormData) => ({
  type: [GET_DATE_AP_REQUEST, GET_DATE_AP_SUCCESS, GET_DATE_AP_FAILURE],
  promise: (api: IApi) => api.prospect.getDate(data),
}))

export const GET_DATE_AR_REQUEST = `${prefix}/GET_DATE_AR_REQUEST`
export const GET_DATE_AR_SUCCESS = `${prefix}/GET_DATE_AR_SUCCESS`
export const GET_DATE_AR_FAILURE = `${prefix}/GET_DATE_AR_FAILURE`

export const getARDate = createAction((data: object | FormData) => ({
  type: [GET_DATE_AR_REQUEST, GET_DATE_AR_SUCCESS, GET_DATE_AR_FAILURE],
  promise: (api: IApi) => api.prospect.getDate(data),
}))

export const LIST_AR_SUMMARY_REQUEST = `${prefix}/LIST_AR_SUMMARY_REQUEST`
export const LIST_AR_SUMMARY_SUCCESS = `${prefix}/LIST_AR_SUMMARY_SUCCESS`
export const LIST_AR_SUMMARY_FAILURE = `${prefix}/LIST_AR_SUMMARY_FAILURE`

export const listARSummary = createAction((id: string, params?: object) => ({
  type: [LIST_AR_SUMMARY_REQUEST, LIST_AR_SUMMARY_SUCCESS, LIST_AR_SUMMARY_FAILURE],
  promise: (api: IApi) => api.prospect.listArSummary(id, params),
  params,
}))

export const UPDATE_AR_SUMMARY_REQUEST = `${prefix}/UPDATE_AR_SUMMARY_REQUEST`
export const UPDATE_AR_SUMMARY_SUCCESS = `${prefix}/UPDATE_AR_SUMMARY_SUCCESS`
export const UPDATE_AR_SUMMARY_FAILURE = `${prefix}/UPDATE_AR_SUMMARY_FAILURE`

export const updateARSummary = createAction((id: string, data: object) => ({
  type: [UPDATE_AR_SUMMARY_REQUEST, UPDATE_AR_SUMMARY_SUCCESS, UPDATE_AR_SUMMARY_FAILURE],
  promise: (api: IApi) => api.prospect.updateArSummary(id, data),
}))

export const LIST_AP_SUMMARY_REQUEST = `${prefix}/LIST_AP_SUMMARY_REQUEST`
export const LIST_AP_SUMMARY_SUCCESS = `${prefix}/LIST_AP_SUMMARY_SUCCESS`
export const LIST_AP_SUMMARY_FAILURE = `${prefix}/LIST_AP_SUMMARY_FAILURE`

export const listAPSummary = createAction((id: string, params?: object) => ({
  type: [LIST_AP_SUMMARY_REQUEST, LIST_AP_SUMMARY_SUCCESS, LIST_AP_SUMMARY_FAILURE],
  promise: (api: IApi) => api.prospect.listApSummary(id, params),
  params,
}))

export const PROSPECT_REFRESH_COUNT = `${prefix}/PROSPECT_REFRESH_COUNT`

export const refreshCount = () => ({
  type: PROSPECT_REFRESH_COUNT,
})

const LIST_AR_DETAIL = createRequestTypes(prefix, 'LIST_AR_DETAIL')

export const [LIST_AR_DETAIL_REQUEST, LIST_AR_DETAIL_SUCCESS, LIST_AR_DETAIL_FAILURE] =
  LIST_AR_DETAIL

export const listARDetail = createAction((id: string, params?: object) => ({
  type: LIST_AR_DETAIL,
  promise: (api: IApi) => api.prospect.listArSummary(id, params),
  params,
}))

const LIST_AP_DETAIL = createRequestTypes(prefix, 'LIST_AP_DETAIL')

export const [LIST_AP_DETAIL_REQUEST, LIST_AP_DETAIL_SUCCESS, LIST_AP_DETAIL_FAILURE] =
  LIST_AP_DETAIL

export const listAPDetail = createAction((id: string, params?: object) => ({
  type: LIST_AP_DETAIL,
  promise: (api: IApi) => api.prospect.listApSummary(id, params),
  params,
}))

const CREATE_NEW_OPS = createRequestTypes(prefix, 'CREATE_NEW_OPS')

export const [CREATE_NEW_OPS_REQUEST, CREATE_NEW_OPS_SUCCESS, CREATE_NEW_OPS_FAILURE] =
  CREATE_NEW_OPS

export const createNewOps = createAction((id: string, params?: object) => ({
  type: CREATE_NEW_OPS,
  promise: (api: IApi) => api.prospect.createNewOps(id, params),
  params,
}))

const DELETE_PROSPECT = createRequestTypes(prefix, 'DELETE_PROSPECT')

export const [DELETE_PROSPECT_REQUEST, DELETE_PROSPECT_SUCCESS, DELETE_PROSPECT_FAILURE] =
  DELETE_PROSPECT

export const deleteProspect = createAction((clientInfoId: string) => ({
  type: DELETE_PROSPECT,
  promise: (api: IApi) => api.prospect.delete(clientInfoId),
}))

const SUBMIT_OPS = createRequestTypes(prefix, 'SUBMIT_OPS')

export const [SUBMIT_OPS_REQUEST, SUBMIT_OPS_SUCCESS, SUBMIT_OPS_FAILURE] = SUBMIT_OPS

export const submitOps = createAction((id: string, params?: object) => ({
  type: SUBMIT_OPS,
  promise: (api: IApi) => api.prospect.submitOps(id, params),
  params,
}))

const PROCESS_FILE = createRequestTypes(prefix, 'PROCESS_FILE')

export const [PROCESS_FILE_REQUEST, PROCESS_FILE_SUCCESS, PROCESS_FILE_FAILURE] = PROCESS_FILE

export const processFile = createAction(
  (opsReportingId: string, fileId: string, isExplicitProcessing: boolean = false) => ({
    type: PROCESS_FILE,
    promise: (api: IApi) => api.prospect.processFile(opsReportingId, fileId, isExplicitProcessing),
    params: { opsReportingId, fileId, isExplicitProcessing },
  }),
)

export const PROCESS_FILES = createRequestTypes(prefix, 'PROCESS_FILES')
export const [PROCESS_FILES_REQUEST, PROCESS_FILES_SUCCESS, PROCESS_FILES_FAILURE] = PROCESS_FILES

export const processFiles = createAction(
  (opsReportingId: string, fileIds: string[], isExplicitProcessing: boolean = false) => ({
    type: PROCESS_FILES,
    promise: (api: IApi) =>
      api.prospect.processFiles(opsReportingId, fileIds, isExplicitProcessing),
    params: { opsReportingId, fileIds, isExplicitProcessing },
  }),
)

export const STOP_FLOW_PROCESSING = createRequestTypes(prefix, 'STOP_FLOW_PROCESSING')
export const [
  STOP_FLOW_PROCESSING_REQUEST,
  STOP_FLOW_PROCESSING_SUCCESS,
  STOP_FLOW_PROCESSING_FAILURE,
] = STOP_FLOW_PROCESSING

export const stopFlowProcessing = createAction((opsReportingId: string, flowId: string) => ({
  type: STOP_FLOW_PROCESSING,
  promise: (api: IApi) => api.prospect.stopFlowProcessing(opsReportingId, flowId),
  params: { opsReportingId, flowId },
}))

export const STOP_FILE_PROCESSING = createRequestTypes(prefix, 'STOP_FILE_PROCESSING')
export const [
  STOP_FILE_PROCESSING_REQUEST,
  STOP_FILE_PROCESSING_SUCCESS,
  STOP_FILE_PROCESSING_FAILURE,
] = STOP_FILE_PROCESSING

export const stopFileProcessing = createAction((opsReportingId: string, fileId: string) => ({
  type: STOP_FILE_PROCESSING,
  promise: (api: IApi) => api.prospect.stopFileProcessing(opsReportingId, fileId),
  params: { opsReportingId, fileId },
}))

const GET_PIPELINE_METRICS = createRequestTypes(prefix, 'GET_PIPELINE_METRICS')

export const [
  GET_PIPELINE_METRICS_REQUEST,
  GET_PIPELINE_METRICS_SUCCESS,
  GET_PIPELINE_METRICS_FAILURE,
] = GET_PIPELINE_METRICS

export const getPipelineMetrics = createAction(() => ({
  type: GET_PIPELINE_METRICS,
  promise: (api: IApi) => api.prospect.getPipelineMetrics(),
}))
